// npm
import React from 'react'

export default function Url() {
  return <p>URL Page</p>
}
